/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { b as __awaiter, c as __generator } from '../../../tslib.es6-e01eabb2.js';
import { extend } from '../../extend/index.js';
import { jsbridgeReady } from '../../jsbridge-ready/index.js';
import { utils } from '../../utils/index.js';
import '../../env/index.js';
import '../../../index-f24a9ec1.js';
import '../../../index-892d8eee.js';
import '../../extend/register/index.js';
import '../../../bridges/dd/index.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';
import '../../jsbridge-ready/nebula/index.js';
import '../../../promise-windvane-85486cec.js';

// 执行
var hideNubelaBack = extend({
    web: {
        nebula: function (options, context) {
            context === null || context === void 0 ? void 0 : context.NBCall('hideTransBack', options);
        },
    },
});
var nebula = (function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var success, fail, promise, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                success = options.success, fail = options.fail;
                promise = jsbridgeReady();
                return [4 /*yield*/, utils.resolvedJsbridge(promise)];
            case 1:
                res = _a.sent();
                if (res.success) {
                    hideNubelaBack().then(success).catch(fail);
                }
                else {
                    fail({ errMsg: 'jsbridgeReady 执行失败' });
                }
                return [2 /*return*/];
        }
    });
}); });

export { nebula as default };
